export default __webpack_public_path__ + "static/IBMPlexSans-LightItalic-Greek-77d4ce9e5e640a18cbb004a786a93535.woff";